import * as React from "react";
import { MetadataGroup } from "./troubleshoot/MetadataGroup";
import { createRoot } from "react-dom/client";

interface MetadataViewerProps {
  metadataItems: Map<string, string>;
}

export default class MetadataViewer extends React.Component<MetadataViewerProps, {}> {
  render() {
    const metaDataItemsByCategoryName = this.extractMetadataByCategory();
    const categoryNames = Object.keys(metaDataItemsByCategoryName);
    return categoryNames.length > 0 ? (
      <div className="metadata">
        {categoryNames.map((it) => (
          <MetadataGroup name={it} items={metaDataItemsByCategoryName[it]} key={it} />
        ))}
      </div>
    ) : null;
  }

  private extractMetadataByCategory() {
    const metaDataItems = this.props.metadataItems;
    const keys = Object.keys(metaDataItems);
    return keys.reduce((acc, currentValue) => {
      let headerKeywords = currentValue.split("-").slice(2);
      let name = headerKeywords[0];
      let key = headerKeywords.slice(1).join(" ");
      if (!acc[name]) {
        acc[name] = new Array<Metadata>();
      }
      acc[name].push({ key: key, value: metaDataItems[currentValue] });
      return acc;
    }, new Map<string, Array<Metadata>>());
  }

  static loadComponent(elementId: string, props: MetadataViewerProps) {
    const container = document.getElementById(elementId);
    const root = createRoot(container!);
    root.render(<MetadataViewer {...props} />);
  }
}
